<script setup>
import ModulePackageTable from '@frontJs/components/tables/projectManagement/modules/ModulePackageTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h, onMounted, ref } from 'vue';

const loading = ref(true);

const data = ref({
    emailingAutomation: 0,
    customerTicket: 0,
});

function updateData() {
    loading.value = true;

    Promise.all([
        axios.post(
            route('front.projectManagement.modules.postModulePackageCount'),
            {
                type: 'emailing_automation',
            },
        ),
        axios.post(
            route('front.projectManagement.modules.postModulePackageCount'),
            {
                type: 'customer_ticket',
            },
        ),
    ])
        .then((response) => {
            data.value.emailingAutomation = response[0].data.count;
            data.value.customerTicket = response[1].data.count;
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    updateData();
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Forfaits modules - Modules - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle> Gestion de projet - Modules - Forfaits modules </PageTitle>

    <TabLayout
        :tabs="{
            emailingAutomation: {
                title: 'Emailing automatisé',
                content: h(ModulePackageTable, { type: 'emailing_automation' }),
            },
            customerTicket: {
                title: 'Tickets clients',
                content: h(ModulePackageTable, { type: 'customer_ticket' }),
            },
        }"
        :loading="loading"
    />
</template>
